import { render, staticRenderFns } from "./adjudicativeDocument.vue?vue&type=template&id=35f9c395&scoped=true&"
import script from "./adjudicativeDocument.vue?vue&type=script&lang=js&"
export * from "./adjudicativeDocument.vue?vue&type=script&lang=js&"
import style0 from "./adjudicativeDocument.vue?vue&type=style&index=0&id=35f9c395&prod&scoped=true&lang=css&"
import style1 from "./adjudicativeDocument.vue?vue&type=style&index=1&id=35f9c395&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9c395",
  null
  
)

export default component.exports